import { useEffect, useMemo, useRef, useState } from "react";
import { RegAnalyticsConstants } from "../../config/constants";

export const useHeightUptoBottom = (targetId: string) => {
  const isMounted = useRef<boolean>(false);
  const [height, setHeight] = useState<string>("");
  useEffect(() => {
    const _isMounted = isMounted;
    _isMounted.current = true;
    return (): void => {
      _isMounted.current = false;
    };
  }, []);
  useEffect(() => {
    const _isMounted = isMounted;
    const onResize = (): void => {
      setTimeout(() => {
        const elem: HTMLElement | null = document.getElementById(targetId);
        const height = window.innerHeight - (elem?.getBoundingClientRect().top ?? 0);
        if (_isMounted.current) {
          setHeight(height + "px");
        }
      }, RegAnalyticsConstants.TimeoutDelay.HeightUpToBottom);
    };
    onResize();
    window.addEventListener("resize", onResize);
    return (): void => {
      window.removeEventListener("resize", onResize);
    };
  }, [targetId]);

  const heightAfterSubtractButtonHeight = useMemo(() => {
    const heightNumber = Number((height ?? "").match(/\d+/)?.[0]);
    const calculatedHeight = !Number.isNaN(heightNumber) ? heightNumber - 43 : 0;
    return `${calculatedHeight}px`;
  }, [height]);

  return { height, heightAfterSubtractButtonHeight };
};
